// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ntext_center[data-v-331b617e] {\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
